// Models
import Model from './Model'
import BankDetails from './BankDetails'

class Beneficiary extends Model {
  get formatters () {
    return {
      bank: data => new BankDetails(data)
    }
  }

  get hasProfile () {
    return this.profileId != null
  }

  get hasWallet () {
    return this.walletId != null
  }

  get hasBankDetails () {
    return this.bank != null
  }

  get hasCorrespondentBankDetails () {
    return this.correspondentBank != null
  }

  get schema () {
    return [
      'accountNumber',
      'address',
      'beneficiaryType',
      'country',
      'name',
      'profileId',
      'regNumber',
      'bank',
      'walletId',
      'correspondentBank',
      'customerProfileId'
    ]
  }
}

export const BENEFICIARY_TYPES = {
  WALLET: 'WALLET',
  FEE: 'FEE',
  CARD_MERCHANT: 'CARD_MERCHANT',
  EXTERNAL: 'EXTERNAL'
}

export default Beneficiary
